import { Component, OnInit, Input } from '@angular/core';
import { FilterService } from '@features/filter/services/filter.service';
import { TabModel } from '../../models/tab.model';

@Component({
  selector: 'app-filter-button',
  templateUrl: './filter-button.component.html',
  styleUrls: ['./filter-button.component.scss'],
})
export class FilterButtonComponent implements OnInit {
  @Input() filterNavigationConfig: TabModel = null;
  @Input() size: 'xs'|'sm'| 'md' = 'md';

  constructor(private filterService: FilterService) {}

  ngOnInit(): void {}

  onFilterButtonClicked() {
    this.filterService.filterNavigationConfig$.next(this.filterNavigationConfig);
  }
}
